import React, {useState} from "react";
import "../interface/app.scss";
import {Router, Switch, Route} from "react-router-dom";
import {createBrowserHistory} from "history";
import Auth from "./login";
import SideBar from "../elements/sideBar";
import Header from "../elements/header";
import DashBoard from "./dashboard";
import Street from "./street";
import * as Constants from "../constants";
import {ToastProvider} from "react-toast-notifications";
import {isIE} from "react-device-detect";

const history = createBrowserHistory();

// Initialize google analytics page view tracking
history.listen((location) => {
    let dirs = location.pathname.split("/");

    if (dirs?.length === 8) {
        Constants.ga4react.initialize().then((ga4) => {
            ga4.pageview(location.pathname);
        });
    } else {
        Constants.ga4react.initialize().then((ga4) => {
            ga4.pageview(location.pathname);
        });
    }
});

interface IStreet {
    name: string;
    id: string;
    debid: string;
}

interface IStreets extends Array<IStreet> {
}

const App = () => {
    const [loggedIn, setLoggedIn] = useState(false);
    const [openedInEdge, setOpenedInEdge] = useState(false);
    const [Streets, setStreets] = useState<IStreets>([]);

    function getStreets() {
        if (Streets.length === 0) {
            Constants.api
                .get("/React/recyclingpoint/all")
                .then((response: any) => {
                    let nStreets: IStreets = [];
                    response?.data?.Result.forEach((street: any) => {
                        let nStreet: IStreet = {
                            name: street.Naam.split(" - ")[0]
                                .replace("Milieustraat", "")
                                .trim(),
                            id: street.Id,
                            debid: street.DefaultDebiteur,
                        };
                        nStreets.push(nStreet);
                    });
                    setStreets(nStreets);
                });
        }
    }

    function setSessionLogin() {
        if (loggedIn) {
            localStorage.setItem("loggedin", JSON.stringify(loggedIn));
        }
    }

    function getSessionLogin() {
        let sessLoggedIn = localStorage.getItem("loggedin")?.toString();
        return sessLoggedIn;
    }

    React.useEffect(() => {
        setSessionLogin();
        if (loggedIn) {
            getStreets();
        }
    }, [loggedIn]);

    React.useEffect(() => {
        setLoggedIn(getSessionLogin() === "true");
    }, []);

    const block = (
        <div className="mobile_block">
            <img src="/logo.svg" width="200" alt=""/>
            <h2>Dashboard alleen op desktop beschikbaar</h2>
            <p>
                Dit dashboard is alleen beschikbaar op een desktop scherm met een
                minimale breedte van 1093px.
            </p>
        </div>
    );

    const loginRouter = (
        <div id="login">
            <Switch>
                <Route
                    path="/logout"
                    render={(props: any) => (
                        <Auth setLoggedIn={setLoggedIn} logout={true}/>
                    )}
                />
                <Route render={(props: any) => <Auth setLoggedIn={setLoggedIn}/>}/>
            </Switch>
        </div>
    );

    React.useEffect(() => {
        if (isIE) {
            if (typeof (navigator as any)?.msLaunchUri === "function") {
                (navigator as any)?.msLaunchUri(
                    "microsoft-edge:" + window.location.href,
                    function () {
                        setOpenedInEdge(true);
                    },
                    function () {
                        setOpenedInEdge(false);
                    }
                );
            }
        }
    }, []);

    if (isIE) {
        return (
            <div className="browser_block">
                <img src="/logo.svg" width="200" alt=""/>
                <h2>Deze browser wordt momenteel niet ondersteund</h2>
                <p>
                    {openedInEdge ? (
                        <>
                            We hebben voor u het dashboard geopend in een nieuwe browser.
                            <br/>
                            Klik{" "}
                            <a
                                className="block"
                                href="https://go.microsoft.com/fwlink/?linkid=2151617"
                            >
                                hier
                            </a>{" "}
                            voor meer informatie.
                        </>
                    ) : (
                        <>
                            Klik{" "}
                            <a
                                className="block"
                                href="https://go.microsoft.com/fwlink/?linkid=2151617"
                            >
                                hier
                            </a>{" "}
                            om uw browser te updaten.
                        </>
                    )}
                </p>
            </div>
        );
    }

    if (!loggedIn) {
        return (
            <Router history={history}>
                {block}
                {loginRouter}
            </Router>
        );
    }

    return (
        <ToastProvider autoDismissTimeout={7000} autoDismiss={true}>
            <Router history={history}>
                {block}
                <div className="App" id="app">
                    <SideBar streets={Streets}/>
                    <section className="app__container">
                        <Header/>
                        <Switch>
                            <Route
                                path="/logout"
                                render={(props: any) => (
                                    <Auth logout={true} setLoggedIn={setLoggedIn}/>
                                )}
                            />
                            <Route path="/dashboard" render={(props: any) => <DashBoard/>}/>
                            <Route
                                path="/street/:id/:debid/:date?/:existing?/:fraction?/:slot?"
                                render={(props) => <Street {...props} />}
                            />
                            <Route render={(props: any) => <DashBoard/>}/>
                        </Switch>
                    </section>
                </div>
            </Router>
        </ToastProvider>
    );
};

export default App;
